// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { PrimeReactProvider } from "primereact/api";
// import "primeflex/primeflex.css";
// import "primereact/resources/primereact.css";
// import "primereact/resources/themes/lara-light-indigo/theme.css";
// import "primeicons/primeicons.css";
// import { ToastContainer } from "react-toastify";
// import { Provider } from 'react-redux';
// import "react-toastify/dist/ReactToastify.css";
// import store from "./store";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   // <React.StrictMode>
//     <PrimeReactProvider>
//       <Provider store={store}>
//         <App />
//       </Provider>
//       <ToastContainer />
//     </PrimeReactProvider>
//   // </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();



import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { PrimeReactProvider } from "primereact/api";
import "primeflex/primeflex.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primeicons/primeicons.css";

import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";

import store from "./store";

// ✅ ADD THIS
import { TranslateProvider } from "./helpers/TranslateContext";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <PrimeReactProvider>

    <Provider store={store}>

      {/* ✅ ADD TranslateProvider */}
      <TranslateProvider>
        <App />
      </TranslateProvider>

    </Provider>

    <ToastContainer />

  </PrimeReactProvider>
);

reportWebVitals();